import React from 'react';
import style from './Carousal.module.css';
import Image from './Image';
const SlideItem = ({ slide }) => {
  return (
    <div className="item">
      <Image src={slide.link} alt={''} message={''} />
      {/* <img className={style.Image} src={slide.link} alt="" height={100} width="100%" /> */}
      <h4 className={style.titleMsg} title={slide.title}>{slide.title}</h4>
      <p className={style.descMsg} title={slide.description}>{slide.description}</p>
      <div style={{ margin: '8px 0px', background: '#b9b9b9', height: '0.5px' }}></div>
      {slide?.choices.map((item, index) => (
        <div key={index}>
          {item.text && (
            <>
              <div className={style.cardChoice}>
                <p title={item.text}>{item.text}</p>
              </div>
            </>
          )}
          {item.url && (
            <>
              <div className={style.cardUrlMsg}>
                <span>
                  <img src="./images/linkLogo.png" alt="" width={12} height={12} />
                </span>
                <a
                  className={style.cardUrlSpanMsg}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={item.url}>
                  {item.url}
                </a>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default SlideItem;
